import React, { useState } from "react"
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, IconButton, Stack, Switch, Typography } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

import { useModal } from "../contexts/modal-context";

const PrintConfigModal = () => {

    const { modalShow, modalData, closeModal } = useModal()

    const [printConfigData, setPrintConfigData] = useState({ header: true, footer: true })

    const handleCloseModal = () => {
        setPrintConfigData({ header: true, footer: true })
        closeModal()
    }

    return (
        <Dialog open={modalShow} onClose={() => { handleCloseModal() }} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ pr: 6 }}>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>Print Configuration</Typography>
                <IconButton onClick={() => { handleCloseModal() }} size="small" sx={{ position: 'absolute', right: 12, top: 12 }}>
                    <CloseRoundedIcon fontSize="small" />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Stack spacing={2}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Typography variant="h6">Header</Typography>
                        <FormControlLabel
                            label=""
                            control={<Switch checked={printConfigData.header} onChange={(e) => { setPrintConfigData({ ...printConfigData, header: e.target.checked }) }} />}
                        />
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Typography variant="h6">Footer</Typography>
                        <FormControlLabel
                            label=""
                            control={<Switch checked={printConfigData.footer} onChange={(e) => { setPrintConfigData({ ...printConfigData, footer: e.target.checked }) }} />}
                        />
                    </Box>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="success" onClick={() => { modalData.submitCallback(printConfigData); handleCloseModal() }}>Continue</Button>
                <Button variant="outlined" onClick={() => { handleCloseModal() }}>Close</Button>
            </DialogActions>
        </Dialog>
    )
}

export default PrintConfigModal